import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { CountryGroupComponent } from './countrygroup.page';
export const routes: Routes = [
    { path: 'countrygroup', component: CountryGroupComponent }
];
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [CountryGroupComponent]
})
export class CountryGroupModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/countrygroup/countrygroup.module.ts